import {fonts} from '../../../../theme/foundations/fonts'
import {pxToRem} from '../../../../utills/pxToRem'

export const giftCardHeading = {
    color: 'black',
    fontFamily: fonts.primary,
    fontSize: [pxToRem(14), pxToRem(14), pxToRem(16), pxToRem(16)],
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: 'normal',
    letterSpacing: pxToRem(1),
    margin: 0
}

export const inputFieldsWrapper = {
    display: 'flex',
    columnGap: pxToRem(10),
    flexWrap: ['wrap', 'wrap', 'nowrap', 'nowrap']
}

export const checkBalanceWraper = {
    display: 'flex',
    columnGap: pxToRem(10),
    justifyContent: 'space-between'
}

export const checkBalanceButton = {
    color: 'cav_red',
    textTransform: 'uppercase',
    fontWeight: '500',
    fontSize: [pxToRem(10), pxToRem(10), pxToRem(12), pxToRem(12)],
    marginTop: pxToRem(10),
    lineHeight: 'normal',
    letterSpacing: pxToRem(1),
    paddingLeft: [pxToRem(10), pxToRem(10), pxToRem(25), pxToRem(25)],
    textDecoration: 'underline',
    alignSelf: 'end',
    '&:hover': {
        textDecoration: 'none'
    }
}

export const formLabelStyle = {
    color: 'black',
    fontFamily: fonts.primary,
    fontSize: [pxToRem(14), pxToRem(14), pxToRem(16), pxToRem(16)],
    fontWeight: '400',
    lineHeight: 'normal',
    letterSpacing: [pxToRem(1), pxToRem(1), pxToRem(1.28), pxToRem(1.28)],
    marginRight: 0
}

export const formLabelStarStyle = {
    ...formLabelStyle,
    display: 'inline',
    color: 'cav_red',
    marginTop: 0
}

export const formErrorMessageStyle = {
    ...formLabelStyle,
    color: 'cav_red_gift_card_error_red',
    fontSize: [pxToRem(12), pxToRem(12), pxToRem(13), pxToRem(13)],
    fontWeight: '400',
    fontStyle: 'italic',
    lineHeight: 'normal',
    letterSpacing: [pxToRem(1)],
    marginTop: pxToRem(10),
    marginBottom: [pxToRem(10), pxToRem(10), pxToRem(15), pxToRem(15)]
}

export const giftCardBalanceStyle = {
    ...formLabelStyle,
    color: 'black',
    fontSize: [pxToRem(14), pxToRem(14), pxToRem(16), pxToRem(16)],
    fontWeight: '500',
    lineHeight: 'normal',
    letterSpacing: [pxToRem(1)],
    marginTop: pxToRem(10),
    marginBottom: [pxToRem(10), pxToRem(10), pxToRem(15), pxToRem(15)]
}

export const giftCardNumberTooltip = {
    background: 'blackAlpha.650',
    color: 'white',
    borderRadius: '0',
    fontFamily: fonts.primary,
    fontSize: pxToRem(13),
    fontWeight: '400',
    letterSpacing: pxToRem(1)
}

export const formInputStyle = {
    height: [pxToRem(35), pxToRem(35), pxToRem(40), pxToRem(40)],
    color: 'black',
    borderColor: 'black',
    borderRadius: 0,
    fontFamily: fonts.primary,
    fontSize: pxToRem(16),
    fontWeight: '400',
    lineHeight: 'normal',
    letterSpacing: [pxToRem(1), pxToRem(1), pxToRem(1.28), pxToRem(1.28)]
}

export const ApplyButton = {
    width: [pxToRem(71), pxToRem(71), pxToRem(92), pxToRem(92)],
    minWidth: [pxToRem(71), pxToRem(71), pxToRem(92), pxToRem(92)],
    height: [pxToRem(35), pxToRem(35), pxToRem(40), pxToRem(40)],
    paddingTop: [pxToRem(12)],
    paddingBottom: [pxToRem(12)],
    paddingLeft: [pxToRem(20)],
    paddingRight: [pxToRem(20)],
    color: 'white',
    backgroundColor: 'cav_red',
    fontFamily: fonts.primary,
    fontSize: [pxToRem(12), pxToRem(12), pxToRem(14), pxToRem(14)],
    fontWeight: 700,
    lineHeight: pxToRem(13.5),
    letterSpacing: pxToRem(1.5),
    textTransform: 'uppercase',
    borderRadius: 0,
    marginLeft: [pxToRem(5), pxToRem(5), pxToRem(10), pxToRem(10)],
    '&:hover': {
        color: 'cav_red',
        backgroundColor: 'white',
        borderColor: 'cav_red',
        border: '1px solid'
    },
    '&:disabled': {
        backgroundColor: 'cav_red',
        '&:hover': {
            color: 'white',
            backgroundColor: 'cav_red'
        }
    }
}

export const addedGiftCard = {
    color: 'cav_yello_green',
    fontFamily: fonts.primary,
    fontSize: [pxToRem(14), pxToRem(14), pxToRem(16), pxToRem(16)],
    fontWeight: '400',
    lineHeight: 'normal',
    letterSpacing: [pxToRem(1)],
    margin: 0,
    display: 'inline'
}

export const removeGiftCard = {
    color: 'cav_pdp_dark_gray',
    fontFamily: fonts.primary,
    fontSize: [pxToRem(10), pxToRem(10), pxToRem(12), pxToRem(12)],
    fontWeight: '500',
    lineHeight: 'normal',
    textTransform: 'uppercase',
    letterSpacing: [pxToRem(1)],
    margin: 0,
    marginLeft: pxToRem(20),
    display: 'inline',
    textDecoration: 'underline',
    '&:hover': {
        textDecoration: 'none'
    }
}
